const CALLBACK_NAME = 'gmapsCallback';
let GOOGLE_MAP_KEY = window._env_.ITH_GCP_TRACKER_API_KEY;

let initialized = !!window.google;
let resolveInitPromise;
let rejectInitPromise;
// This promise handles the initialization
// status of the google maps script.
const initPromise = new Promise((resolve, reject) => {
    resolveInitPromise = resolve;
    rejectInitPromise = reject;
});

export default function gmapsInit() {
    // If Google Maps already is initialized
    // the `initPromise` should get resolved
    // eventually.
    if (initialized) return initPromise;

    initialized = true;
    // The callback function is called by
    // the Google Maps script if it is
    // successfully loaded.
    window[CALLBACK_NAME] = () => resolveInitPromise(window.google);

    // We inject a new script tag into
    // the `<head>` of our HTML to load
    // the Google Maps script.
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAP_KEY}&callback=${CALLBACK_NAME}&libraries=places`;
    script.onerror = rejectInitPromise;
    document.querySelector('head').appendChild(script);

    return initPromise;
}


export function rectangle_from_position(position, distance) {
    const metersPerDegreeLat = 111320; // Approximate value
    const metersPerDegreeLng = 111320 * Math.cos(position.lat * (Math.PI / 180)); // Adjust for latitude

    console.log('position', position);
    const latOffset = distance / 2 / metersPerDegreeLat;
    const lngOffset = distance / 2 / metersPerDegreeLng;

    console.log("latOffset", latOffset);
    console.log("lngOffset", lngOffset);

// Define the rectangle bounds
    const bounds = {
        north: position.lat + latOffset,
        south: position.lat - latOffset,
        east: position.lng + lngOffset,
        west: position.lng - lngOffset,
    };

    return {
        type: "Polygon",
        coordinates: [[
            [bounds.west, bounds.north],
            [bounds.east, bounds.north],
            [bounds.east, bounds.south],
            [bounds.west, bounds.south],
            [bounds.west, bounds.north],
        ]],
    };
}

function getPolygonCenter(polygon) {
    const path = polygon.getPath();
    let latSum = 0;
    let lngSum = 0;

    path.forEach((latLng) => {
        latSum += latLng.lat();
        lngSum += latLng.lng();
    });

    const centerLat = latSum / path.getLength();
    const centerLng = lngSum / path.getLength();

    return new google.maps.LatLng(centerLat, centerLng);
}

// Function to move the polygon to a new center
export function movePolygon(polygon, newCenter) {
    const currentCenter = getPolygonCenter(polygon);

    // Calculate the latitude and longitude offset
    const latOffset = newCenter.lat - currentCenter.lat();
    const lngOffset = newCenter.lng - currentCenter.lng();

    // Create a new path by applying the offset to each vertex
    const newPath = polygon.getPath().getArray().map((latLng) => {
        return {
            lat: latLng.lat() + latOffset,
            lng: latLng.lng() + lngOffset
        };
    });

    // Set the new path to the polygon
    polygon.setPath(newPath);
}

export function polygon_from_polylines(zone, circle) {
    const path = circle.getPath().getArray().map(coord => [coord.lng(), coord.lat()]);
    if (path.length && (path[0][0] !== path[path.length - 1][0] || path[0][1] !== path[path.length - 1][1])) {
        path.push(path[0]);
    }
    return {
        type: "Polygon",
        coordinates: [path]
    };

          }